var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpcoming = function SvgUpcoming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160-120q-33 0-56.5-23.5T80-200v-200q0-33 23.5-56.5T160-480h200q0 50 35 85t85 35 85-35 35-85h200q33 0 56.5 23.5T880-400v200q0 33-23.5 56.5T800-120zm0-80h640v-200H664q-25 55-74.5 87.5T480-280t-109.5-32.5T296-400H160zm544-328-56-56 142-142 56 56zm-448 0L114-670l56-56 142 142zm184-112v-200h80v200zM160-200h640z"
  })));
};
export default SvgUpcoming;